document.addEventListener('DOMContentLoaded', () => {
    const images = [
        '/landing-page/screenshotDemoZoo.png',
        '/landing-page/screenshotDerby.png',
        '/landing-page/screenshotWahn.png',
    ]
    let i = 0
    const laptopImage = document.getElementById('laptop-image')

    setInterval(() => {
        laptopImage.classList.add('opacity-0')
        setTimeout(() => {
            i = (i + 1) % images.length
            laptopImage.src = images[i]
            laptopImage.classList.remove('opacity-0')
        }, 1000) // Match this duration with the CSS transition duration
    }, 7000)
})
